import * as zod from 'zod';

export const CNCOperateAutodoorVariables = zod.object({});

export type CNCOperateAutodoorVariables = zod.infer<
  typeof CNCOperateAutodoorVariables
>;
